var e = /* @__PURE__ */ ((a) => (a.Erstelldatum = "createdAt", a.Hersteller = "make", a.Rate = "rate", a.Standzeit = "stime", a.VerfugbarAb = "availableAt", a.Verkaufspreis = "vk", a.Zufall = "random", a.TakeIn = "takein", a.Views = "clicks", a))(e || {}), s = /* @__PURE__ */ ((a) => (a.ASC = "ASC", a.DESC = "DESC", a))(s || {});
export {
  s as FilterOrder,
  e as FilterSort
};
